import fetch from './fetch.helper';

export const fetchDevices = () => fetch('get', 'devices');
export const fetchDeviceById = (id) => fetch('get', `devices/${id}`);
export const postDevice = (device) => fetch('post', 'devices', null, device);
export const swapReadings = ({ from, to }) => fetch('post', 'devices/swap', null, { from, to });
export const putDevice = (deviceId, changes) => fetch('put', `devices/${deviceId}`, null, changes);
export const fetchUsersByDeviceId = (id) => fetch('get', `users/device/${id}`);
export const fetchDataForProvider = id => fetch('get', `devices/provider/${id}`);
export const postTankInquiry = (email, message) =>
  fetch(
    'post',
    'support',
    {},
    {
      subject: `New Tank Inquiry from ${email}`,
      message,
    },
  );
